/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A5Inputs */

const et_faq_a5 = /** @type {(inputs: Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parim viis reklaamikuludest sõltuvust vähendada on ehitada orgaanilise nähtavuse süsteem. SEO, lokaalne otsing, sisuturundus ja Google Mapsi optimeerimine aitavad jõuda inimesteni, kes juba otsivad sinu toodet või teenust. Tasuline reklaam võib tuua kiireid tulemusi, kuid liiklus kaob sageli siis, kui eelarve peatub. Orgaaniline SEO töötab teisiti: iga hästi optimeeritud leht, artikkel ja teenuseleht võib tuua päringuid kuude või aastate jooksul. ScalingWebsi fookus on sellise pikaajalise digitaalse vara ehitamisel.`)
};

const en_faq_a5 = /** @type {(inputs: Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The best way to reduce dependence on ad spend is to build an organic visibility system. SEO, local search, content marketing, and Google Maps optimization help you reach people who are already searching for your product or service. Paid ads can deliver fast results, but traffic often disappears when the budget stops. Organic SEO works differently: every well-optimized page, article, and service page can generate inquiries for months or years. ScalingWebs focuses on building this kind of long-term digital asset.`)
};

/**
* | output |
* | --- |
* | "The best way to reduce dependence on ad spend is to build an organic visibility system. SEO, local search, content marketing, and Google Maps optimization he..." |
*
* @param {Faq_A5Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a5 = /** @type {((inputs?: Faq_A5Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A5Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a5(inputs)
	return en_faq_a5(inputs)
});